import BaseService from './BaseService';
import entities from 'src/config/entities';

class LogService extends BaseService{

  constructor() {
    super({ entity: entities.LOG });
  }
}

export default new LogService();
